module.exports = __webpack_public_path__ + "img/Group 1866.e6eb09cd.svg";